import React from "react";

function CaretDown() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M13.3538 6.35378L8.35375 11.3538C8.30732 11.4003 8.25217 11.4372 8.19147 11.4623C8.13077 11.4875 8.06571 11.5004 8 11.5004C7.9343 11.5004 7.86923 11.4875 7.80853 11.4623C7.74783 11.4372 7.69269 11.4003 7.64625 11.3538L2.64625 6.35378C2.55243 6.25996 2.49973 6.13272 2.49973 6.00003C2.49973 5.86735 2.55243 5.7401 2.64625 5.64628C2.74007 5.55246 2.86732 5.49976 3 5.49976C3.13269 5.49976 3.25993 5.55246 3.35375 5.64628L8 10.2932L12.6463 5.64628C12.6927 5.59983 12.7479 5.56298 12.8086 5.53784C12.8693 5.5127 12.9343 5.49976 13 5.49976C13.0657 5.49976 13.1308 5.5127 13.1915 5.53784C13.2521 5.56298 13.3073 5.59983 13.3538 5.64628C13.4002 5.69274 13.4371 5.74789 13.4622 5.80859C13.4873 5.86928 13.5003 5.93434 13.5003 6.00003C13.5003 6.06573 13.4873 6.13079 13.4622 6.19148C13.4371 6.25218 13.4002 6.30733 13.3538 6.35378Z"
        fill="#3A383F"
      />
    </svg>
  );
}

export default CaretDown;
